import { gql } from "@apollo/client";

export const DEPLOY = gql`
  mutation Deploy {
    deploy
  }
`;

export const GET_CURRENCY = gql`query Currency { currency }`;
